import React from 'react';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';


export default class RegionScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = { currentRegion: {id: null, 
                                       name: ""}};

        this.handleChangeName = this.handleChangeName.bind(this);  
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.region && this.props.args.region.length > 0) {
            BaseApi.get("/region", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.region}, withCredentials: true})
            .then(res => { 
                this.setState({currentRegion: res.data})
            })    
            .catch()
        }
    }


    save(event) {
        BaseApi.post('/region', this.state.currentRegion, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeName(event) {
        var currentRegion = this.state.currentRegion
        currentRegion.name = event.target.value
        this.setState({currentRegion: currentRegion})
    }

    openLocations() {
        this.props.navigate("locations", 
        {caller: "region", callargs: this.props.args, regionid: this.props.args.region})

    }

    render() {

        const regionExists = this.state.currentRegion.id;
    
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Регион"}/>

                <div className="row mt-4">
                    <div className="col-lg-8">
                         <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    {regionExists ? "Редактирование региона" : "Новый регион"}
                                </h6>
                                <form>
                                    <div class="form-group">
                                        <label for="name"> Наименование:</label>
                                        <input type="text" class="form-control w-100" id="name" value={this.state.currentRegion.name} onChange={this.handleChangeName} />

                                        <div className="mt-4 d-flex justify-content-end">
                                            <div class="row mt-3">
                                                <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                                            </div>
                                        </div>   
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>


                     <div className="col-lg-4 mt-4 mt-lg-0">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Действия</h6>
                           
                                {regionExists && (
                                    <div>
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.openLocations()}}>
                                                Населенные пункты
                                        </button>  
                                    </div>
                                )}
                                {!regionExists && (
                                    <p className="text-muted mb-0">
                                    Дополнительные действия станут доступны после сохранения записи.
                                    </p>
                                )}
                            </div>    
                        </div>
                    </div>
                </div>

                {/*            
                <div class="row mt-5">
                    <div class="col-md-6">
                        <form>
                            <div class="form-group">
                                <label for="name"> Наименование:</label>
                                <input type="text" class="form-control w-100" id="name" value={this.state.currentRegion.name} onChange={this.handleChangeName} />
                            </div>
                        </form>
                    </div>
                    <div class="col-md-3 offset-3">
                        <div class="row">
                            <button class="btn btn-primary w-100" onClick={()=>{this.openLocations()}}>Населенные пункты</button>   
                        </div>
                        <div class="row mt-3">
                            <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                        </div>
                    </div>
                </div>
                */}
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/region.js